<ion-content class="coupon-details-content">
 
  <!-- Header -->
  <div class="header-bar">
    <ion-icon name="chevron-back-outline" class="back-icon"></ion-icon>
  </div>

  <ion-card class="coupon-card">

    <!-- Banner -->
    <div class="banner-container">
      <img *ngIf="form.get('couponMedia')?.value?.length"
           [src]="form.get('couponMedia')?.value[0]?.url"
           class="banner-image" />
    </div>

    <!-- Location -->
    <div class="location-info section-padding">
      <h2 class="restaurant-name">
        {{ form.get('title')?.value }}
      </h2>

      <div class="location-detail" *ngIf="selectedStore?.length">
        <span class="location-text">
          <img src="assets/vector/VectorLocation.svg" class="location-icon" />
          {{ selectedStore[0]?.name }}, {{ selectedStore[0]?.address }}
        </span>
      </div>
    </div>

    <div class="view-more-wrapper" *ngIf="selectedStore && selectedStore.length > 1">
      <span class="view-more-text">
        View More Locations
      </span>
    </div>

    <hr class="divider" />

    <!-- Coupon Section -->
    <div class="coupon-section section-padding">

      <div class="coupon-header">
        <p class="coupon-title">Coupon Information</p>
      </div>

      <!-- Title + Categories -->
      <div class="coupon-heading">
        <p class="main-coupon-title">
          {{ form.get('title')?.value }}
        </p>

        <div class="category-row">
          <div class="category" *ngFor="let eachC of selectedCategory">
            {{ eachC?.name }}
          </div>
        </div>
      </div>

      <!-- Highlight -->
      <div class="coupon-highlight-box">
        <div class="coupon-text-group">
          <p class="coupon-label">This coupon is worth</p>
          <h2 class="coupon-value">
            ${{ form.get('couponValue')?.value || 0 }}
          </h2>
        </div>

        <img src="../../../assets/img/image_ coins.svg" class="coins-icon" />
      </div>

      <!-- Details -->
      <div class="second-row">

        <!-- Min spend + Time -->
        <div class="details">

          <span class="detail-item"
                *ngIf="form.get('minimumSpending')?.value">
            <img src="../../../assets/img/vector.svg" class="icon" />
            ${{ form.get('minimumSpendingValue')?.value }} min. spend
          </span>

          <span class="detail-item"
                *ngIf="form.get('redemptionInSpecificHour')?.value">
            <img src="../../../../assets/img/Vector (1).svg" class="icon" />
            {{ form.get('redemptionInSpecificHoursFrom')?.value }} -
            {{ form.get('redemptionInSpecificHoursTo')?.value }}
          </span>

        </div>

        <!-- Info Column -->
        <div class="info-column">

          <!-- Dates -->
          <div class="info-row"
               *ngIf="form.get('redemptionStartDate')?.value">
            <img src="../../../../assets/img/icon_ calendar (1).svg" class="icon" />
            From
            <span class="bold">
              {{ form.get('redemptionStartDate')?.value | date:'dd MMM yyyy' }}
            </span>
            to
            <span class="bold">
              {{ form.get('redemptionEndDate')?.value | date:'dd MMM yyyy' }}
            </span>
          </div>

          <!-- Age -->
          <div class="info-row"
               *ngIf="form.get('ageRestriction')?.value">
            Age:
            <span class="bold">
              {{ form.get('ageRestrictionValue')?.value }}+
            </span>
          </div>

          <!-- Quantity -->
          <div class="info-row">
            <ng-container *ngIf="form.get('unlimitedQuantity')?.value; else limitedQty">
              Quantity: <span class="bold">Unlimited</span>
            </ng-container>

            <ng-template #limitedQty>
              <ng-container *ngIf="form.get('quantity')?.value">
                Quantity: <span class="bold">{{ form.get('quantity')?.value }}</span>
              </ng-container>
            </ng-template>
          </div>

          <!-- Max claim -->
          <div class="info-row"
               *ngIf="form.get('maximumClaimPerCustomer')?.value">
            Max claim per customer:
            <span class="bold">
              {{ form.get('maximumClaimPerCustomer')?.value }}
            </span>
          </div>

          <div class="info-row min-tier" *ngIf="selectedTier">
            Min. Membership Tier:
            <img *ngIf="selectedTier.url" [src]="selectedTier.url" alt="tier" class="icon" />
            <span class="bold"> {{ selectedTier.name }} </span>
          </div>

        </div>

        <!-- Description -->
        <div class="description">
          <h2 class="desc-header">Description</h2>

          <ion-text class="description-text"
                    *ngIf="form.get('additionalDesc')?.value; else noDesc">
            {{ form.get('additionalDesc')?.value }}
          </ion-text>

          <ng-template #noDesc>
            <ion-text color="medium">
              No description available.
            </ion-text>
          </ng-template>
        </div>

      </div>
    </div>

    <hr class="divider" />

    <!-- Terms -->
    <div class="terms-section section-padding">
      <h4 class="terms-title">Terms and Conditions</h4>

      <p class="terms-text"
         *ngIf="form.get('additionalTnc')?.value; else noTnc"
         [innerHTML]="form.get('additionalTnc')?.value">
      </p>

      <ng-template #noTnc>
        <p class="terms-text text-muted">
          No terms and conditions available.
        </p>
      </ng-template>
    </div>

  </ion-card>

  <!-- Footer -->
  <!-- <div class="points-container sticky-footer">
    <ion-toolbar>
      <ion-button expand="block" color="danger">
        Snatch to Save
      </ion-button>
    </ion-toolbar>
  </div> -->

</ion-content>